// extracted by mini-css-extract-plugin
export default {"root":"giphy-picker_root__ZPt9v","container":"giphy-picker_container__iB2Gm","gif-item":"giphy-picker_gif-item__d+Jk8","img-container":"giphy-picker_img-container__ggzjF"};